import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from "react-router-dom";
import {setPage, getPageNum} from '../../actions/index';

class Pagination extends Component {
	componentDidMount() {
		window.onpopstate = ()=> {
			var pageNum = this.props.getPageNum();
			this.props.setPage(pageNum);
		}
	}

	updateUrlWithPage(pageNum) {
		// Get current URL and parameters
		const url = new URL(window.location.href);
		const searchParams = url.searchParams;
		
		// Update or add page parameter
		searchParams.set('page', pageNum);
		
		// Construct new URL path with updated parameters
		const newPath = `${location.pathname}?${searchParams.toString()}`;
		
		// Update browser history
		this.props.history.push(newPath);
	}

	handlePageNumClick(event) {
		event.preventDefault();
		let pageNum = 1;

		this.resetPageHighlight();
		if (parseInt(event.target.getAttribute('data-pageNum'))) {
			pageNum = event.target.getAttribute('data-pageNum');
			event.target.setAttribute('class','page-numbers current');
		}

		this.updateUrlWithPage(pageNum);
		this.props.setPage(pageNum);
	}

	handleNextClick(event) {
		event.preventDefault();
		let pageNum = parseInt(this.props.pagination.pageNum) + 1;
		this.updateUrlWithPage(pageNum);

		this.resetPageHighlight();
		this.props.setPage(pageNum);
	}

	handlePrevClick(event) {
		event.preventDefault();
		let pageNum = parseInt(this.props.pagination.pageNum) - 1;
		this.updateUrlWithPage(pageNum);

		this.resetPageHighlight();
		this.props.setPage(pageNum);
	}

	resetPageHighlight() {
		let pages = document.getElementsByClassName("page-numbers");

		for(var e = 0; e < pages.length; e++) {
			var page = pages[e];
			page.setAttribute('class','page-numbers');
		}
	}

	renderPageNumbers() {
		if (1 < parseInt(this.props.pagination.totalPages)) {
			let pageNumbers = [1, 2, 3, 4, 5]; // default
			if (6 > parseInt(this.props.pagination.totalPages)) { // less than 6 pages
				pageNumbers = [];
				for (var i = 1; i <= parseInt(this.props.pagination.totalPages); i++) {
					pageNumbers.push(i);
				}
			} else if (parseInt(this.props.pagination.pageNum) > (parseInt(this.props.pagination.totalPages) - 6 )) { // less than 6 pages from the end
				pageNumbers = [];
				for (var i = (parseInt(this.props.pagination.totalPages) - 5 ); i < parseInt(this.props.pagination.totalPages); i++) {
					pageNumbers.push(i);
				}
			} else if (5 < parseInt(this.props.pagination.pageNum)) { // after page 6.
				let max  = parseInt(this.props.pagination.totalPages),
					curr = parseInt(this.props.pagination.pageNum),
					k    = Math.ceil(max/4),
					n = 0, m, j = 1;

				while (j < k) {
					if ((5 * j) >= curr) {
						m = (5 * j) - curr;
						n = 4 - m;
						break;
					} else {
						j++;
					}
				}

				pageNumbers = [];
				for (var i = parseInt(this.props.pagination.pageNum) - n; i <= (parseInt(this.props.pagination.pageNum) + m); i++) {
						pageNumbers.push(i);
				}
			}

			return (pageNumbers.map(ind => {
					return (
						<button type="button" key={ind} className={(parseInt(this.props.pagination.pageNum) === parseInt(ind)) ? 'page-numbers current' : 'page-numbers'} onClick={this.handlePageNumClick.bind(this)} data-pageNum={ind}>{ind}</button>
					);
				})
			);
		}
	}

	renderFirstPage() {
		if (5 < parseInt(this.props.pagination.pageNum)) {
			return (<button type="button" className="page-numbers" onClick={this.handlePageNumClick.bind(this)} data-pageNum="1">
			<span>1...</span></button>);
		}
	}

	renderPrevious() {
		if (1 < parseInt(this.props.pagination.pageNum)) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handlePrevClick.bind( this ) }>
				<i className="fa-solid fa-chevron-left"></i><span
				className="sr-only">Previous</span>
			</button>
			);
		}
	}

	renderNext() {
		if ( (parseInt( this.props.pagination.totalPages )
		     ) > parseInt(this.props.pagination.pageNum)) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handleNextClick.bind( this ) }>
				<i className="fa-solid fa-chevron-right"></i><span
				className="sr-only">Next</span>
			</button>
			);
		}
	}

	renderLastPage() {
		if ( 5 < parseInt( this.props.pagination.totalPages ) ) {
			if ((parseInt(this.props.pagination.totalPages)) > parseInt(this.props.pagination.pageNum) + 5) {
				return (<button type="button" className="page-numbers" onClick={this.handlePageNumClick.bind(this)} data-pageNum={parseInt(this.props.pagination.totalPages)}>
			   <span>...</span>{this.props.pagination.totalPages}
				</button>);
			} else {
				return (<button type="button" className="page-numbers" onClick={this.handlePageNumClick.bind(this)} data-pageNum={parseInt(this.props.pagination.totalPages)}>
						{this.props.pagination.totalPages}
				</button>);
			}
		}
	}

	render() {
		return (<nav aria-label="" className="pagination">
			{this.renderPrevious()}
		    {this.renderFirstPage()}
			{this.renderPageNumbers()}
			{this.renderLastPage()}
			{this.renderNext()}
		</nav>);
	}
}

function mapStateToProps({pagination}) {
	return {pagination};
}

export default withRouter(connect(mapStateToProps, {setPage, getPageNum})(Pagination));
